import {translate} from '@ngneat/transloco';
import {POIntegrationObject} from '@obj-models/POIntegrationObject';

export class POAccessGroup extends POIntegrationObject {
  static type = 'AccessGroup';
  public id: number;

  constructor() {
    super();
    this.type = POAccessGroup.type;
    this.id = 0;
    this.label = '';
    this.active = true;
  }

  static getOneStrAGList(
    list: POAccessGroup[],
    type: 'short' | 'full' = 'full'
  ) {
    if (!list?.length) return '<' + translate('obj.access-group.empty') + '>';
    let result = '';
    for (const ag of list) {
      if (result !== '') {
        result += ', ';
      }
      result += ag.label;
    }
    if (type === 'short' && result.length > 64) {
      return `${result.slice(0, 62)}...`;
    }
    return result;
  }
}
